var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFilePhotoIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Image",
    style: {
      enableBackground: "new 0 0 32 32"
    },
    viewBox: "0 0 32 32",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#D2ECFA;}\r\n\t.st1{fill:#20AD74;}\r\n\t.st2{fill:#FBC34E;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M2.163,25.953l6.783-10.392c0.369-0.566,1.306-0.566,1.675,0l2.668,4.088l5.459-8.72   c0.183-0.292,0.503-0.469,0.848-0.469s0.665,0.178,0.848,0.47l9.405,15.04c0.107,0.171,0.152,0.367,0.146,0.562   c0-0.011,0.006-0.02,0.006-0.031v-21c0-0.552-0.447-1-1-1H3c-0.552,0-1,0.448-1,1v21c0,0.015,0.008,0.027,0.008,0.042   C2,26.337,2.047,26.131,2.163,25.953z M9.5,13.804c-1.654,0-3-1.346-3-3s1.346-3,3-3s3,1.346,3,3S11.154,13.804,9.5,13.804z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M29.994,26.531c0.006-0.195-0.039-0.39-0.146-0.562l-9.405-15.04c-0.183-0.292-0.503-0.47-0.848-0.47   s-0.665,0.177-0.848,0.469l-5.459,8.72l-2.668-4.088c-0.369-0.566-1.306-0.566-1.675,0L2.163,25.953   C1.733,26.593,2.232,27.509,3,27.5h26C29.525,27.495,29.987,27.061,29.994,26.531z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 9.5,
    cy: 10.804,
    r: 3
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilePhotoIcon);
export default __webpack_public_path__ + "static/media/File_Photo_Icon.a1fe33e937ab62fc623f01c171a65a2b.svg";
export { ForwardRef as ReactComponent };